var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExclamationMark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 14.5a.813.813 0 0 0 .597-.246.813.813 0 0 0 .247-.598.813.813 0 0 0-.247-.597.813.813 0 0 0-.597-.246.813.813 0 0 0-.597.246.813.813 0 0 0-.247.597c0 .234.082.433.247.598A.813.813 0 0 0 10 14.5Zm-.844-3.375h1.688V5.5H9.156v5.625ZM10 19a8.769 8.769 0 0 1-3.492-.703 9.074 9.074 0 0 1-2.871-1.934 9.074 9.074 0 0 1-1.934-2.871A8.769 8.769 0 0 1 1 10c0-1.25.234-2.418.703-3.504a9.074 9.074 0 0 1 4.805-4.793A8.769 8.769 0 0 1 10 1c1.25 0 2.418.234 3.504.703a9.113 9.113 0 0 1 4.793 4.793A8.747 8.747 0 0 1 19 10a8.769 8.769 0 0 1-.703 3.492 9.074 9.074 0 0 1-4.793 4.805A8.747 8.747 0 0 1 10 19Z",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationMark);
export default __webpack_public_path__ + "static/media/exclamation-mark.54e398f6.svg";
export { ForwardRef as ReactComponent };